import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);
import MicroModal from 'micromodal';
import { createApp } from 'vue';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
//@ts-ignore
import Hotspot from "../vue/components/hotspot/hotspot";
//@ts-ignore
import HotspotMobile from "../vue/components/hotspot/hotspotMobile";
//@ts-ignore
import ProductSets from "../vue/components/productSets/productSets";
//@ts-ignore
import Recipes from "../vue/components/recipes/recipes";
//@ts-ignore
import Blogs from "../vue/components/blogs/blogs";
//@ts-ignore
import RecipesMobile from "../vue/components/recipes/recipesMobile";
import { GetProductById, GetProductSetById, GetProductSetItemsById, GetHotspotFeaturedImage } from 'Apis/apis';

export namespace ProductDetail {
	
	//load swiper for the modal
	let setupModalSwiper = () => {
		const swiper = new Swiper(`.js-swiper-modal`, {
			slidesPerView: 4,
			spaceBetween: 10,
			centerInsufficientSlides: true,

			// Navigation arrows
			navigation: {
				nextEl: `.modal__swiper .swiper-button-next`,
				prevEl: `.modal__swiper .swiper-button-prev`,
			},

			breakpoints: {
				0: {
					slidesPerView: 3,
					spaceBetween: 10,
				},
				768: {
					slidesPerView: 7,
					spaceBetween: 10,
				},
				992: {
					slidesPerView: 10,
					spaceBetween: 10,
				},
			}
		});
	};

	//setup the accordion menus
	let setupAccordions = () => {
		let accordions = document.querySelectorAll('.js-accordion');

		accordions.forEach((accordion) => {
			let triggers = accordion.querySelectorAll('.js-accordion-trigger');

			triggers.forEach((trigger) => {
				trigger.addEventListener('click', (e) => {
					triggers.forEach((el) => {
						if(el !== trigger) {
							el.closest('.js-accordion-item').classList.remove('state-open');
						}
					});


					trigger.closest('.js-accordion-item').classList.toggle('state-open');
					e.preventDefault();
				})
			});
		});
	};

	//setup the modal click events and functions
	let microModalSetup = () => {
		let modalLinks = document.querySelectorAll('.js-product-modal');
		let innerModalLinks = document.querySelectorAll('.js-inner-product-modal');
		let loadingSpinner = document.querySelector('.js-modal-spinner');
		let featuredYTVideoItem = document.querySelector('.js-selected-item[data-type="featuredYTVideo"]');

		//These are the 3 main types where the big content loads
		let imageItem = document.querySelector('.js-selected-item[data-type="image"]');
		let youtubeItem = document.querySelector('.js-selected-item[data-type="youtube"]');
		let threesixtyItem = document.querySelector('.js-selected-item[data-type="threesixty"]');
		let cookieconsentItem = document.querySelector('.js-selected-item[data-type="cookieconsent"]');		


		let setupModalLinks = () => {
			modalLinks.forEach((modalLink) => {
				modalLink.addEventListener('click', (e) => {
					let selectedItem = {};
					selectedItem = checkAgainstData(modalLink, selectedItem);

					MicroModal.show('productModal', {
						onShow: modal => openCallback(selectedItem),
						onClose: modal => closeCallback(selectedItem),
					});
					e.preventDefault();
				});
			});
		};

		let setupSwiper = () => {
			let pdSliders = document.querySelectorAll('.js-product-swiper-wrapper');
			var breakpoint = window.matchMedia('(min-width: 992px)');

			//For Each Hero Slider Loop through and setup swiper
			pdSliders.forEach((slider, index) => {
				slider.classList.add(`product-detail__swiper--${index}`);
				let dynamicSlide = slider.querySelector('.js-dynamic-slide') ? slider.querySelector('.js-dynamic-slide') : null;
				let clonedDynamicSlide:any = dynamicSlide ? dynamicSlide.cloneNode(true) : null;
				let swiperWrapper = slider.querySelector('.swiper-wrapper');
				let mobVidElement = <HTMLMediaElement>document.getElementById("MobileFeaturedVideo");
				if (mobVidElement != null) {
					mobVidElement.pause();
				}

				const swiper = new Swiper(`.product-detail__swiper--${index}`, {
					slidesPerView: 1,
					spaceBetween: 0,

					// If we need pagination
					pagination: {
						el: `.product-detail__swiper--${index} .swiper-pagination`,
						clickable: true
					},

					// Navigation arrows
					navigation: {
						nextEl: `.product-detail__swiper--${index} .swiper-button-next`,
						prevEl: `.product-detail__swiper--${index} .swiper-button-prev`,
					},

					breakpoints: {
						0: {
							slidesPerView: 1,
							spaceBetween: 0,
						},
						992: {
							slidesPerView: 4,
							spaceBetween: 30,
						}
					},
				});

				function toggleNavigation() {
					if (breakpoint.matches) {
						if(slider.querySelector('.js-dynamic-slide')) {
							slider.querySelector('.js-dynamic-slide').remove();
							swiper.update();
						}
					} else {
						if(!slider.querySelector('.js-dynamic-slide')) {
							swiperWrapper.prepend(clonedDynamicSlide);
							swiper.update();
						}
					}
					setupModalLinks();
				}

				toggleNavigation();
				breakpoint.addListener(toggleNavigation);
			});
		};

		setupSwiper();

		//openCallback gets fired when the Micromodal opens
		let openCallback = (selectedItem) => {

			//This is a shared function between the products on the detail page and the products in the modal
			let checkAgainstClicked = (selected) => {
				imageItem.classList.remove('state-active');
				youtubeItem.classList.remove('state-active');
				threesixtyItem.classList.remove('state-active');
				cookieconsentItem.classList.remove('state-active');
				featuredYTVideoItem.classList.remove('state-active');
				//set the initial active item 
				if(selected?.type === "image") {
					//start our loading spinner
					loadingSpinner.classList.add('state-visible');
					//clean up videos if they are playing
					const sourceElement = threesixtyItem.querySelector('source');
					sourceElement.src = '';
					let theVideo = featuredYTVideoItem.querySelector('iframe');
					theVideo.setAttribute('src', '');
					let theIframe = youtubeItem.querySelector('iframe');
					theIframe.setAttribute('src', '');

					//set the image
					imageItem.setAttribute('src', selected.img);
					imageItem.setAttribute('alt', selected.alt);
					//when the images are done loading set it to visible and remove the spinner
					imageItem.addEventListener('load',(e) => {
						imageItem.classList.add('state-active');
						//hide the loading spinner
						loadingSpinner.classList.remove('state-visible');
					});
				} else if(selected?.type === "cookieconsent") {
					cookieconsentItem.classList.add('state-active');
				} 
				else if(selected?.type === "youtube") {
					loadingSpinner.classList.add('state-visible');
					//clean up videos if they are playing
					const sourceElement = threesixtyItem.querySelector('source');
					sourceElement.src = '';
					let theVideo = featuredYTVideoItem.querySelector('iframe');
					theVideo.setAttribute('src', '');

					//set youtube iframe src
					let theIframe = youtubeItem.querySelector('iframe');
					theIframe.setAttribute('src', `https://www.youtube.com/embed/${selected.youtubeID}?enablejsapi=1&autoplay=1&rel=0&origin=${window.location.protocol + "//" + window.location.hostname}`);
					loadingSpinner.classList.remove('state-visible');
					youtubeItem.classList.add('state-active');
				} 
				else if(selected?.type === "threesixty") {
					loadingSpinner.classList.add('state-visible');
					//clean up videos if they are playing
					let theIframe = youtubeItem.querySelector('iframe');
					theIframe.setAttribute('src', '');
					let theVideo = featuredYTVideoItem.querySelector('iframe');
					theVideo.setAttribute('src', '');

					const sourceElement = threesixtyItem.querySelector('source');
					sourceElement.src = selected.video;
					(threesixtyItem as HTMLVideoElement).load();
					loadingSpinner.classList.remove('state-visible');
					threesixtyItem.classList.add('state-active');
				}
				else if (selected?.type === "featuredYTVideo") {
					console.log("faturedYTVideo");
					loadingSpinner.classList.add('state-visible');
					//clean up videos if they are playing
					const sourceElement = threesixtyItem.querySelector('source');
					sourceElement.src = '';
					let theIframe = youtubeItem.querySelector('iframe');
					theIframe.setAttribute('src', '');

					let theVideo = featuredYTVideoItem.querySelector('iframe');
					theVideo.setAttribute('src', `https://www.youtube.com/embed/${selected.featuredyoutube}?enablejsapi=1&rel=0&origin=${window.location.protocol + "//" + window.location.hostname}`);
					/*(featuredYTVideoItem as HTMLVideoElement).load();*/
					loadingSpinner.classList.remove('state-visible');
					featuredYTVideoItem.classList.add('state-active');
				}
			};

			//When the open callback runs we take our passed in data from the element that was clicked on
			//and set the appropriate content type in the large area of the modal.
			checkAgainstClicked(selectedItem);

			innerModalLinks.forEach((innerModalLink) => {
				innerModalLink.addEventListener("click", (e) => {
					innerModalLinks.forEach((innerModalLink) => {
						innerModalLink.classList.remove('state-active');
					});

					let selectedInnerModalLinkData = {};
					selectedInnerModalLinkData = checkAgainstData(innerModalLink, selectedInnerModalLinkData);
					checkAgainstClicked(selectedInnerModalLinkData);
					innerModalLink.classList.add('state-active');
					e.preventDefault();
				});

				//when the modal first loads set the current item in the thumbnail list to be the active one
				if (innerModalLink.getAttribute('data-type') === "featuredYTVideo" && innerModalLink.getAttribute('data-youtube-id') === selectedItem.featuredyoutube) {
					innerModalLink.classList.add('state-active');
				} else if(innerModalLink.getAttribute('data-type') === "image" && innerModalLink.getAttribute('data-img') === selectedItem.img ) {
					innerModalLink.classList.add('state-active');
				} else if(innerModalLink.getAttribute('data-type') === "threesixty" && innerModalLink.getAttribute('data-video') === selectedItem.video) {
					innerModalLink.classList.add('state-active');
				} else if(innerModalLink.getAttribute('data-type') === "youtube" && innerModalLink.getAttribute('data-youtube-id') === selectedItem.youtubeID) {
					innerModalLink.classList.add('state-active');
				} 
			});
		};

		let closeCallback = (selectedItem) => {
			imageItem.classList.remove('state-active');
			youtubeItem.classList.remove('state-active');
			youtubeItem.querySelector('iframe').setAttribute('src', '');
			threesixtyItem.classList.remove('state-active');
			cookieconsentItem.classList.remove('state-active');			
			let sourceElement = threesixtyItem.querySelector('source');
			sourceElement.src = '';
			featuredYTVideoItem.classList.remove('state-active');
			featuredYTVideoItem.querySelector('iframe').setAttribute('src', '');

			//remove Active states from thumbnail items
			innerModalLinks.forEach((innerModalLink) => {
				innerModalLink.classList.remove('state-active');
			});
		};

		let checkAgainstData = (linkToCheck, selectedItem) => {
			selectedItem["type"] = linkToCheck.getAttribute('data-type') || undefined;
			selectedItem["img"] = linkToCheck.getAttribute('data-img') || undefined;
			selectedItem["alt"] = linkToCheck.getAttribute('data-alt') || undefined;
			selectedItem["video"] = linkToCheck.getAttribute('data-video') || undefined;
			selectedItem["youtubeID"] = linkToCheck.getAttribute('data-youtube-id') || undefined;
			selectedItem["featuredyoutube"] = linkToCheck.getAttribute('data-youtube-id') || undefined;
			return selectedItem;
		};
	}

	let setupProductSetsVue = async() => {
		let productSetsEl = document.querySelector('.js-product-sets');
		if(productSetsEl && productSetsEl.getAttribute('data-product-id')) {
			const app = createApp(ProductSets);
			app.use(PerfectScrollbar, {
				watchOptions: true,
				options: {
					suppressScrollX: true
				}
			});
			app.mount('.js-product-sets');
		}
	}

	let setupRecipes = async() => {
		let recipesEl = document.querySelector('.js-recipes');
		if(recipesEl && recipesEl.getAttribute('data-product-id')) {
			const app = createApp(Recipes);
			app.use(PerfectScrollbar, {
				watchOptions: true,
			});
			app.mount('.js-recipes');
		}
	}

	let setupBlogs = async () => {
		let blogsEl = document.querySelector('.js-blogs');
		if (blogsEl && blogsEl.getAttribute('data-product-id')) {
			const app = createApp(Blogs);			
			app.use(PerfectScrollbar, {
				watchOptions: true,
			});			
			app.mount('.js-blogs');
		}
	}
	
	let setupYouTubeUseCare = () => {
		let modalItems = document.querySelectorAll('.js-youtube-usecare-play');
		
		if (modalItems.length) {
			modalItems.forEach((modalItem) => {
				modalItem.addEventListener('click', (e) => {
					MicroModal.show('modal-youtube-usecare', {						
						onClose: function () {
							stopAllVideos();
						}
						
					});
					e.preventDefault();
				});
			});
		}
		let stopAllVideos = () => {
			let iframes = document.querySelectorAll('.modal__iframe');
			iframes.forEach((iframe) => {
				let originalSrc = iframe.getAttribute('src');
				iframe.setAttribute('src', originalSrc);
			});
		};
	};

	let getHotspotImage = async() => {
		let hotspotEl = document.querySelector('.js-hotspot');
		if(hotspotEl && hotspotEl.getAttribute('data-hotspotId')) {
			const app = createApp(Hotspot);
			app.mount('.js-hotspot');
		}
	}


	export const init = () => {
		setupAccordions();
		setupModalSwiper();
		MicroModal.init();
		microModalSetup();
		setupProductSetsVue();
		getHotspotImage();
		setupRecipes();
		setupBlogs();
		setupYouTubeUseCare();
	}
}


document.addEventListener('DOMContentLoaded', ProductDetail.init);
